// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import { 
//   FiUsers, 
//   FiUserCheck, 
//   FiPhoneCall, 
//   FiMessageCircle,
//   FiCalendar,
//   FiSearch,
//   FiRefreshCw,
//   FiChevronLeft,
//   FiChevronRight,
//   FiUser,
//   FiMail,
//   FiPhone,
//   FiBriefcase,
//   FiTrendingUp,
//   FiAward,
//   FiStar
// } from "react-icons/fi";
// import { getUsersReportWithParams } from "../../services/userReportService";
// import "./UserReportLayer.css";

// const ITEMS_PER_PAGE = 10;

// // Status list for the dropdown
// const STATUS_OPTIONS = [
//   "New Lead", "Contacted", "Interested", "Not Interested", 
//   "Call Back", "Demo Scheduled", "Follow-up", "Negotiation", 
//   "Decision Pending", "Won", "Lost"
// ];

// const UserReportLayer = () => {
//   const [data, setData] = useState([]);
//   const [summary, setSummary] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [page, setPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState("");

//   const [filters, setFilters] = useState({
//     role: "",
//     from: "",
//     to: "",
//     call_status: "", 
//   });

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({ ...prev, [name]: value }));
//   };

//   const fetchData = useCallback(async (isInitial = false) => {
//     setLoading(true);
//     try {
//       const params = {};
//       if (filters.role) params.role = filters.role;
//       if (filters.call_status) params.call_status = filters.call_status;
//       if (filters.from && filters.to) {
//         params.from = filters.from;
//         params.to = filters.to;
//       }

//       const res = await getUsersReportWithParams(params);
//       setData(res?.data || []);
//       setSummary(res?.summary || {});
      
//       if (!isInitial) setPage(1); 
//     } catch (error) {
//       console.error("Error loading user report:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [filters]);

//   useEffect(() => {
//     fetchData(true);
//   }, [fetchData]);

//   const getRoleLabel = (role) => {
//     const labels = { tm: "Team Manager", sales: "Sales Executive" };
//     return labels[role] || role || "-";
//   };

//   const getRoleIcon = (role) => {
//     if (role === "tm") return <FiUserCheck />;
//     if (role === "sales") return <FiBriefcase />;
//     return <FiUser />;
//   };

//   const getStatusIcon = (status) => {
//     if (!status) return <FiTrendingUp />;
//     const icons = {
//       "New Lead": <FiStar />,
//       "Contacted": <FiPhoneCall />,
//       "Interested": <FiTrendingUp />,
//       "Not Interested": <FiUser />,
//       "Call Back": <FiRefreshCw />,
//       "Demo Scheduled": <FiCalendar />,
//       "Follow-up": <FiMessageCircle />,
//       "Negotiation": <FiBriefcase />,
//       "Decision Pending": <FiAward />,
//       "Won": <FiAward />,
//       "Lost": <FiUser />
//     };
//     return icons[status] || <FiTrendingUp />;
//   };

//   const filteredData = useMemo(() => {
//     const term = searchTerm.toLowerCase().trim();
//     if (!term) return data;

//     return data.filter((user) => {
//       return (
//         user.name?.toLowerCase().includes(term) ||
//         user.email?.toLowerCase().includes(term) ||
//         user.mobile?.includes(term)
//       );
//     });
//   }, [data, searchTerm]);

//   const { paginatedData, totalPages } = useMemo(() => {
//     const total = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
//     const sliced = filteredData.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);
//     return { paginatedData: sliced, totalPages: total || 1 };
//   }, [filteredData, page]);

//   return (
//     <div className="report-container">
//       <div className="title-section">
//         <h5 className="title">User Report Dashboard</h5>
//         <div className="title-stats">
//           <span className="stat-badge">
//             <FiUsers /> Total Users: {summary.total_users || 0}
//           </span>
//         </div>
//       </div>

//       {/* Filter Section */}
//       <div className="filters">
//         <select name="role" value={filters.role} onChange={handleFilterChange}>
//           <option value="">All Roles</option>
//           <option value="tm">Team Manager</option>
//           <option value="sales">Sales Executive</option>
//         </select>

//         <select name="call_status" value={filters.call_status} onChange={handleFilterChange}>
//           <option value="">All Status</option>
//           {STATUS_OPTIONS.map((status) => (
//             <option key={status} value={status}>{status}</option>
//           ))}
//         </select>

//         <input type="date" name="from" value={filters.from} onChange={handleFilterChange} placeholder="From Date" />
//         <input type="date" name="to" value={filters.to} onChange={handleFilterChange} placeholder="To Date" />

//         <div className="search-wrapper">
//           <FiSearch className="search-icon" />
//           <input 
//             type="text" 
//             placeholder="Search Name, Email, or Mobile..." 
//             value={searchTerm}
//             onChange={(e) => {
//               setSearchTerm(e.target.value);
//               setPage(1);
//             }}
//             className="search-input"
//           />
//         </div>

//         <button onClick={() => fetchData()} disabled={loading} className="refresh-btn">
//           <FiRefreshCw className={loading ? "spinning" : ""} />
//           {loading ? "Updating..." : "Refresh Data"}
//         </button>
//       </div>

//       {/* Summary Cards */}
//       <div className="summary-grid">
//         <div className="card">
//           <div className="card-icon users-icon">
//             <FiUsers />
//           </div>
//           <div className="card-content">
//             <span className="label">Total Users</span>
//             <span className="value">{summary.total_users || 0}</span>
//           </div>
//         </div>
//         <div className="card">
//           <div className="card-icon leads-icon">
//             <FiTrendingUp />
//           </div>
//           <div className="card-content">
//             <span className="label">Total Leads</span>
//             <span className="value">{summary.total_leads || 0}</span>
//           </div>
//         </div>
//         <div className="card">
//           <div className="card-icon calls-icon">
//             <FiPhoneCall />
//           </div>
//           <div className="card-content">
//             <span className="label">Calls Made</span>
//             <span className="value">{summary.total_calls || 0}</span>
//           </div>
//         </div>
//         <div className="card">
//           <div className="card-icon followups-icon">
//             <FiMessageCircle />
//           </div>
//           <div className="card-content">
//             <span className="label">Followups</span>
//             <span className="value">{summary.total_followups || 0}</span>
//           </div>
//         </div>
//       </div>

//       {/* Data Table */}
//       <div className="table-wrapper">
//         <table className="report-table">
//           <thead>
//             <tr>
//               <th>User</th>
//               <th>Role</th>
//               <th>Contact Info</th>
//               <th>Leads</th>
//               <th>Calls</th>
//               <th>Latest Status</th>
//               <th>Followups</th>
//             </tr>
//           </thead>
//           <tbody>
//             {loading ? (
//               <tr><td colSpan="7" className="loading-cell">
//                 <div className="loader"></div>
//                 Loading records...
//               </td></tr>
//             ) : paginatedData.length > 0 ? (
//               paginatedData.map((user) => (
//                 <tr key={user.id}>
//                   <td>
//                     <div className="user-cell">
//                       <strong>{user.name}</strong>
//                       <small>{user.email}</small>
//                     </div>
//                   </td>
//                   <td>
//                     <span className="role-badge">
//                       {getRoleIcon(user.role)}
//                       {getRoleLabel(user.role)}
//                     </span>
//                   </td>
//                   <td>
//                     <div className="contact-cell">
//                       <span><FiMail /> {user.email}</span>
//                       <span><FiPhone /> {user.mobile}</span>
//                     </div>
//                   </td>
//                   <td><span className="stat-number">{user.stats?.total_leads || 0}</span></td>
//                   <td><span className="stat-number">{user.stats?.total_calls || 0}</span></td>
//                   <td>
//                     <span className={`status-badge ${(user.calls?.[0]?.call_status || "none").toLowerCase().replace(/\s+/g, '-')}`}>
//                       {getStatusIcon(user.calls?.[0]?.call_status)}
//                       {user.calls?.[0]?.call_status || "N/A"}
//                     </span>
//                   </td>
//                   <td><span className="stat-number">{user.stats?.total_followups || 0}</span></td>
//                 </tr>
//               ))
//             ) : (
//               <td colSpan="7" className="no-data">
//                 <FiUsers className="no-data-icon" />
//                 <p>No results found</p>
//                 <small>Try adjusting your search or filters</small>
//               </td>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="pagination">
//           <button disabled={page === 1} onClick={() => setPage(p => p - 1)}>
//             <FiChevronLeft /> Prev
//           </button>
//           <span className="page-info">
//             Page {page} of {totalPages}
//           </span>
//           <button disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>
//             Next <FiChevronRight />
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UserReportLayer;


import React, { useEffect, useState, useCallback, useMemo } from "react";
import { 
  FiUsers, 
  FiUserCheck, 
  FiPhoneCall, 
  FiMessageCircle,
  FiCalendar,
  FiSearch,
  FiRefreshCw,
  FiChevronLeft,
  FiChevronRight,
  FiUser,
  FiMail,
  FiPhone,
  FiBriefcase,
  FiTrendingUp,
  FiAward,
  FiStar,
  FiClock
} from "react-icons/fi";
import { getUsersReportWithParams } from "../../services/userReportService";
import { getLeadStatuses } from "../../services/leadService";
import "./UserReportLayer.css";

const ITEMS_PER_PAGE = 10;



const UserReportLayer = () => {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const [filters, setFilters] = useState({
    role: "",
    from: "",
    to: "",
    call_status: "", 
    source: "",
  });

  const [statuses, setStatuses] = useState([]);

  useEffect(() => {
    const loadStatuses = async () => {
      try {
        const statRes = await getLeadStatuses();
        if (statRes.status === "success") setStatuses(statRes.data || []);
      } catch (error) {
        console.error("Status load error:", error);
      }
    };
    loadStatuses();
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const fetchData = useCallback(async (isInitial = false) => {
    setLoading(true);
    try {
      const params = {};
      if (filters.role) params.role = filters.role;
      if (filters.call_status) params.call_status = filters.call_status;
      if (filters.source) params.source = filters.source;
      if (filters.from && filters.to) {
        params.from = filters.from;
        params.to = filters.to;
      }

      const res = await getUsersReportWithParams(params);
      setData(res?.data || []);
      setSummary(res?.summary || {});
      
      if (!isInitial) setPage(1); 
    } catch (error) {
      console.error("Error loading user report:", error);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchData(true);
  }, [fetchData]);

  const getRoleLabel = (role) => {
    const labels = { tm: "Team Manager", sales: "Sales Executive" };
    return labels[role] || role || "-";
  };

  const getRoleIcon = (role) => {
    if (role === "tm") return <FiUserCheck />;
    if (role === "sales") return <FiBriefcase />;
    return <FiUser />;
  };

  const formatStatusLabel = (status) => {
    if (!status) return "";
    return status
      .toString()
      .trim()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .replace(/\bSram\b/g, "SRAM")
      .replace(/\bDnd\b/g, "DND")
      .replace(/\bDont\b/g, "Don’t");
  };

  const getStatusIcon = (status) => {
    const label = formatStatusLabel(status);
    if (!label) return <FiTrendingUp />;
    const icons = {
      "New Lead": <FiStar />,
      "Contacted": <FiPhoneCall />,
      "Interested": <FiTrendingUp />,
      "Not Interested": <FiUser />,
      "Call Back": <FiRefreshCw />,
      "Demo Scheduled": <FiCalendar />,
      "Follow Up": <FiMessageCircle />,
      "Negotiation": <FiBriefcase />,
      "Decision Pending": <FiAward />,
      "Won": <FiAward />,
      "Lost": <FiUser />,
      "Need Information": <FiClock />,
      "SRAM Orders Close": <FiAward />,
      "Orders Close In Markets": <FiAward />,
      "Meeting Scheduled": <FiCalendar />,
      "Quotation Sent": <FiMail />,
      "Payment Pending": <FiAward />,
      "Converted": <FiAward />,
      "Duplicate": <FiUser />,
      "Don’t Call Again": <FiUser />,
      "DND": <FiUser />,
      "Lost Lead": <FiUser />,
      "Closed": <FiAward />,
      "Assigned": <FiUserCheck />,
    };
    return icons[label] || <FiTrendingUp />;
  };

  // Helper to get pending calls (total - answered)
  const getPendingCalls = (stats) => {
    if (!stats) return 0;
    const total = stats.total_calls || 0;
    const answered = stats.answered_calls || 0;
    return total - answered;
  };

  const filteredData = useMemo(() => {
    let result = [...data];
    
    const term = searchTerm.toLowerCase().trim();
    if (term) {
      result = result.filter((user) => {
        return (
          user.name?.toLowerCase().includes(term) ||
          user.email?.toLowerCase().includes(term) ||
          user.mobile?.includes(term)
        );
      });
    }

    if (filters.source) {
      result = result.filter(user => 
        user.leads?.some(lead => lead.source?.toLowerCase() === filters.source.toLowerCase()) || 
        user.calls?.some(call => call.lead_source?.toLowerCase() === filters.source.toLowerCase())
      );
    }
    
    return result;
  }, [data, searchTerm, filters]);

  const { paginatedData, totalPages } = useMemo(() => {
    const total = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
    const sliced = filteredData.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);
    return { paginatedData: sliced, totalPages: total || 1 };
  }, [filteredData, page]);

  return (
    <div className="report-container">
      <div className="title-section">
        <h5 className="title">User Report Dashboard</h5>
        <div className="title-stats">
          <span className="stat-badge">
            <FiUsers /> Total Users: {summary.total_users || 0}
          </span>
        </div>
      </div>

      {/* Filter Section */}
      <div className="filters">
        <select name="role" value={filters.role} onChange={handleFilterChange}>
          <option value="">All Roles</option>
          <option value="tm">Team Manager</option>
          <option value="sales">Sales Executive</option>
        </select>

        <select name="call_status" value={filters.call_status} onChange={handleFilterChange}>
          <option value="">All Lead Status</option>
          {[...statuses].sort((a, b) => (a.name || "").localeCompare(b.name || "")).map((s) => (
            <option key={s.id} value={s.name.toLowerCase().replace(/\s+/g, "_")}>
              {formatStatusLabel(s.name)}
            </option>
          ))}
        </select>

        <select name="source" value={filters.source} onChange={handleFilterChange}>
          <option value="">All Sources</option>
          <option value="Website">Website</option>
          <option value="Facebook">Facebook</option>
          <option value="Google Ads">Google Ads</option>
          <option value="Reference">Reference</option>
        </select>

        <input type="date" name="from" value={filters.from} onChange={handleFilterChange} placeholder="From Date" />
        <input type="date" name="to" value={filters.to} onChange={handleFilterChange} placeholder="To Date" />

        <div className="search-wrapper">
          <FiSearch className="search-icon" />
          <input 
            type="text" 
            placeholder="Search Name, Email, or Mobile..." 
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setPage(1);
            }}
            className="search-input"
          />
        </div>

        <button onClick={() => fetchData()} disabled={loading} className="refresh-btn">
          <FiRefreshCw className={loading ? "spinning" : ""} />
          {loading ? "Updating..." : "Refresh Data"}
        </button>
      </div>

      {/* Summary Cards */}
      <div className="summary-grid">
        <div className="card">
          <div className="card-icon users-icon">
            <FiUsers />
          </div>
          <div className="card-content">
            <span className="label">Total Users</span>
            <span className="value">{summary.total_users || 0}</span>
          </div>
        </div>
        <div className="card">
          <div className="card-icon leads-icon">
            <FiTrendingUp />
          </div>
          <div className="card-content">
            <span className="label">Total Leads</span>
            <span className="value">{summary.total_leads || 0}</span>
          </div>
        </div>
        <div className="card">
          <div className="card-icon calls-icon">
            <FiPhoneCall />
          </div>
          <div className="card-content">
            <span className="label">Calls Made</span>
            <span className="value">{summary.total_calls || 0}</span>
          </div>
        </div>
        <div className="card">
          <div className="card-icon followups-icon">
            <FiMessageCircle />
          </div>
          <div className="card-content">
            <span className="label">Followups</span>
            <span className="value">{summary.total_followups || 0}</span>
          </div>
        </div>
      </div>

      {/* Data Table */}
      <div className="table-wrapper">
        <table className="report-table">
          <thead>
            <tr>
              <th>User</th>
              <th>Role</th>
              <th>Contact Info</th>
              <th>Leads</th>
              <th>Calls</th>
              <th>Incoming</th>
              <th>Outgoing</th>
              <th>Pending</th>
              <th>Latest Status</th>
              <th>Followups</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="10" className="loading-cell">
                <div className="loader"></div>
                Loading records...
              </td></tr>
            ) : paginatedData.length > 0 ? (
              paginatedData.map((user) => {
                const stats = user.stats || {};
                return (
                  <tr key={user.id}>
                    <td>
                      <div className="user-cell">
                        <strong>{user.name}</strong>
                        <small>{user.email}</small>
                      </div>
                    </td>
                    <td>
                      <span className="role-badge">
                        {getRoleIcon(user.role)}
                        {getRoleLabel(user.role)}
                      </span>
                    </td>
                    <td>
                      <div className="contact-cell">
                        <span><FiMail /> {user.email}</span>
                        <span><FiPhone /> {user.mobile}</span>
                      </div>
                    </td>
                    <td><span className="stat-number">{stats.total_leads || 0}</span></td>
                    <td><span className="stat-number">{stats.total_calls || 0}</span></td>
                    <td><span className="stat-number">{stats.incoming_calls || 0}</span></td>
                    <td><span className="stat-number">{stats.outgoing_calls || 0}</span></td>
                    <td><span className="stat-number">{stats.pending_calls || 0}</span></td>
                    <td>
                      {(() => {
                        const statusValue = user.calls?.[0]?.call_status;
                        const statusLabel = statusValue ? formatStatusLabel(statusValue) : "N/A";
                        const badgeClass = statusLabel.toLowerCase().replace(/\s+/g, "-");
                        return (
                          <span className={`status-badge ${badgeClass}`}>
                            {getStatusIcon(statusValue)}
                            {statusLabel}
                          </span>
                        );
                      })()}
                    </td>
                    <td><span className="stat-number">{stats.total_followups || 0}</span></td>
                  </tr>
                );
              })
            ) : (
              <tr><td colSpan="10" className="no-data">
                <FiUsers className="no-data-icon" />
                <p>No results found</p>
                <small>Try adjusting your search or filters</small>
              </td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pagination">
          <button disabled={page === 1} onClick={() => setPage(p => p - 1)}>
            <FiChevronLeft /> Prev
          </button>
          <span className="page-info">
            Page {page} of {totalPages}
          </span>
          <button disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>
            Next <FiChevronRight />
          </button>
        </div>
      )}
    </div>
  );
};

export default UserReportLayer;